/*
 * Edge LAN-direct connection mechanism — SHARED across every Vitesse product UI
 * (the gateway app, the fleet admin, future products). A gateway's OWN edge
 * api-gateway is reachable on the customer LAN via the FIXED per-NIC Plex names
 * `<role>.<fp>.gateway.vitesseautomation.ai` (role = it / ot / wifi). Each is a
 * Cloudflare A-record → the box's real LAN IP for that NIC (written cloud-side by
 * fleet-control from the box's NetworkState), and the box's per-edge Let's-Encrypt
 * WILDCARD cert `*.<fp>.gateway.vitesseautomation.ai` covers every one — so the
 * browser gets TRUSTED TLS straight to a LAN IP, no warning.
 *
 * This is the ONE copy of the URL contract: it builds the LAN candidate URLs only.
 * Adopting them — the LAN-vs-cloud race + live failover — is each app's concern
 * (its transport layer), but the URL shape must NOT drift, which is why it lives
 * here. Everything is vitesseautomation.ai + plain Cloudflare DNS — no dashed-IP
 * names, no custom DNS server, no legacy domain (the retired v1 scheme).
 */
/** The Plex wildcard zone every gateway's edge api-gateway is reachable under. */
export const EDGE_PLEX_DOMAIN = 'gateway.vitesseautomation.ai';
/** The LAN-direct candidate URLs for a gateway — one per host NIC the box reports.
 *  Pure + side-effect-free (safe to call per render). Empty if no fingerprint. */
export function lanCandidates(deviceFingerprint, net) {
    if (!deviceFingerprint)
        return [];
    const legs = [];
    const add = (role, ip) => {
        const v = (ip ?? '').trim();
        if (v)
            legs.push({ role, ip: v, url: `https://${role}.${deviceFingerprint}.${EDGE_PLEX_DOMAIN}` });
    };
    add('it', net.itIp);
    add('ot', net.otIp);
    add('wifi', net.wifiIp);
    return legs;
}
//# sourceMappingURL=plex.js.map